<div class="sf-dialog">

  <div class="sf-header">
    <h2 class="sf-title">
      <mat-icon>logout</mat-icon>
      Salir fin de día · {{ data.optimalWallet.nombre }}
    </h2>
    <button mat-icon-button class="close-button" (click)="cerrar()" [disabled]="ejecutando" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="sf-content">

    <div class="sf-info">
      Se cerrarán en el broker las operaciones seleccionadas. Las órdenes OCO (Stop Loss / Take Profit)
      de cada operación se cancelan al forzar la salida.
    </div>

    <div *ngIf="cargando" class="sf-loading">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Consultando operaciones abiertas...</span>
    </div>

    <div *ngIf="errorMsg" class="alert alert-warning">{{ errorMsg }}</div>

    <div *ngIf="!cargando && !errorMsg && filas.length === 0" class="alert alert-info">
      No hay operaciones entradas pendientes de salida en esta cartera.
    </div>

    <div *ngIf="!cargando && filas.length > 0 && conSalidaPendiente > 0" class="alert alert-warning">
      {{ conSalidaPendiente }} operación(es) tienen la salida del modelo pendiente de enviar al broker: siguen
      abiertas y se preseleccionan para cerrarlas aquí.
    </div>

    <div *ngIf="!cargando && filas.length > 0 && conFinDiaActivo === 0 && conSalidaPendiente === 0" class="alert alert-info">
      Ningún modelo de estas operaciones tiene la salida de fin de día activa, por lo que no hay operaciones
      preseleccionadas. Puede marcarlas manualmente.
    </div>

    <div class="sf-toolbar" *ngIf="!cargando && filas.length > 0">
      <span class="sf-selected-count">
        {{ selection.selected.length }} de {{ filas.length }} seleccionada(s) · {{ conFinDiaActivo }} con salida fin de día activa
        <ng-container *ngIf="conSalidaPendiente > 0"> · {{ conSalidaPendiente }} con salida pendiente</ng-container>
        <ng-container *ngIf="ejecutando || terminado"> · {{ progreso }}/{{ selection.selected.length }} procesadas</ng-container>
      </span>
      <div class="sf-actions">
        <button mat-stroked-button (click)="cerrar()" [disabled]="ejecutando">{{ terminado ? 'Cerrar' : 'Cancelar' }}</button>
        <button mat-flat-button color="primary" (click)="confirmar()"
                [disabled]="ejecutando || terminado || selection.selected.length === 0">
          <mat-spinner *ngIf="ejecutando" diameter="16"></mat-spinner>
          Cerrar {{ selection.selected.length }} seleccionada(s)
        </button>
      </div>
    </div>

    <mat-progress-bar *ngIf="ejecutando" mode="determinate"
                      [value]="selection.selected.length ? (progreso / selection.selected.length) * 100 : 0"></mat-progress-bar>

    <div *ngIf="!cargando && filas.length > 0" class="sf-table-wrapper wrapper2 tableStyle">
      <table cdk-table [dataSource]="filas" class="table-striped tableStyle">

        <ng-container cdkColumnDef="select">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">
            <mat-checkbox (change)="toggleAll()" [checked]="todasSeleccionadas()" [disabled]="ejecutando"></mat-checkbox>
          </th>
          <td cdk-cell *cdkCellDef="let f">
            <mat-checkbox *ngIf="f.seleccionable" (click)="$event.stopPropagation()" (change)="toggleFila(f)"
                          [checked]="selection.isSelected(f)" [disabled]="ejecutando"></mat-checkbox>
            <span *ngIf="!f.seleccionable" class="sf-badge sf-badge-nd" [matTooltip]="f.motivo">N/D</span>
          </td>
        </ng-container>

        <ng-container cdkColumnDef="isooper">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">ID</th>
          <td cdk-cell *cdkCellDef="let f">{{ f.op.isooper }}</td>
        </ng-container>

        <ng-container cdkColumnDef="compania">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">Compañía</th>
          <td cdk-cell *cdkCellDef="let f">{{ f.op.nombreCompania || f.op.ticker }}</td>
        </ng-container>

        <ng-container cdkColumnDef="modelo">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">Modelo</th>
          <td cdk-cell *cdkCellDef="let f">{{ f.modelo }}</td>
        </ng-container>

        <ng-container cdkColumnDef="findia">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">Salida fin de día</th>
          <td cdk-cell *cdkCellDef="let f">
            <span *ngIf="f.finDia === true" class="sf-badge sf-badge-ok">Sí</span>
            <span *ngIf="f.finDia === false" class="sf-badge sf-badge-nd">No</span>
            <span *ngIf="f.finDia === null" class="sf-badge sf-badge-nd" matTooltip="No se pudo leer la configuración del modelo">N/D</span>
          </td>
        </ng-container>

        <ng-container cdkColumnDef="pendiente">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">Salida pendiente</th>
          <td cdk-cell *cdkCellDef="let f">
            <span *ngIf="f.op.salidaPendiente as sp" class="sf-badge sf-badge-warn"
                  matTooltip="El modelo ya dio la salida pero no se envió al broker ({{ sp.estadoEnvio }}). La posición sigue abierta.">
              {{ sp.estadoEnvio }}
            </span>
            <span *ngIf="!f.op.salidaPendiente" class="sf-muted">—</span>
          </td>
        </ng-container>

        <ng-container cdkColumnDef="sentido">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">Sentido</th>
          <td cdk-cell *cdkCellDef="let f" [ngClass]="f.op.bajista ? 'numero-negativo' : 'numero-positivo'">{{ sentido(f) }}</td>
        </ng-container>

        <ng-container cdkColumnDef="cantidad">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">N° Acciones</th>
          <td cdk-cell *cdkCellDef="let f">{{ f.op.cantidadacciones | number:'1.0-2' }}</td>
        </ng-container>

        <ng-container cdkColumnDef="entrada">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">Precio entrada</th>
          <td cdk-cell *cdkCellDef="let f">{{ f.op.precioentradareal }}</td>
        </ng-container>

        <ng-container cdkColumnDef="oco">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">OCO a cancelar</th>
          <td cdk-cell *cdkCellDef="let f">
            <span *ngIf="f.sl" class="sf-badge sf-badge-sl">SL {{ f.op.pricestp > 0 ? f.op.pricestp : '' }}</span>
            <span *ngIf="f.tp" class="sf-badge sf-badge-tp">TP {{ f.op.pricelmt > 0 ? f.op.pricelmt : '' }}</span>
            <span *ngIf="!f.sl && !f.tp" class="sf-muted">—</span>
          </td>
        </ng-container>

        <ng-container cdkColumnDef="estado">
          <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">Resultado</th>
          <td cdk-cell *cdkCellDef="let f">
            <mat-spinner *ngIf="f.estado === 'ejecutando'" diameter="14"></mat-spinner>
            <span *ngIf="f.estado === 'ok'" class="sf-badge sf-badge-ok">Cerrada</span>
            <span *ngIf="f.estado === 'error'" class="sf-badge sf-badge-error" [matTooltip]="f.msg">Error</span>
            <span *ngIf="f.estado === 'pendiente'" class="sf-muted">{{ f.seleccionable ? '' : f.motivo }}</span>
          </td>
        </ng-container>

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" [class.selected]="selection.isSelected(row)"></tr>
      </table>
    </div>

  </div>
</div>
